import styled from "styled-components";

// Colored dot rendered before a tooltip row to indicate its line color.
export const TooltipColorDot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color || "currentColor"};
  margin-right: 6px;
  flex: 0 0 8px;
`;
